import { createReducer, on } from '@ngrx/store';
import { IcpState, initialIcpState } from './icp.state';
import * as IcpActions from './icp.actions';

export const icpReducer = createReducer(
  initialIcpState,
  
  // Load ICPs
  on(IcpActions.loadIcps, (state) => ({
    ...state,
    icps: {
      ...state.icps,
      loading: true,
      error: null
    }
  })),
  
  on(IcpActions.loadIcpsSuccess, (state, { icps, pagination }) => ({
    ...state,
    icps: {
      entities: icps,
      loading: false,
      error: null,
      pagination: {
        total: pagination.total,
        per_page: pagination.per_page,
        current_page: pagination.current_page,
        last_page: pagination.last_page,
        from: pagination.from,
        to: pagination.to
      }
    }
  })),
  
  on(IcpActions.loadIcpsFailure, (state, { error }) => ({
    ...state,
    icps: {
      ...state.icps,
      loading: false,
      error: error.message || 'Failed to load ICPs'
    }
  })),
  
  // Load ICP Detail
  // Get ICP Detail actions
  on(IcpActions.getIcpDetail, (state) => ({
    ...state,
    icpDetail: {
      ...state.icpDetail,
      loading: true,
      error: null
    }
  })),
  
  on(IcpActions.getIcpDetailSuccess, (state, { icp }) => ({
    ...state,
    icpDetail: {
      entity: icp,
      loading: false,
      error: null
    }
  })),
  
  on(IcpActions.getIcpDetailFailure, (state, { error }) => ({
    ...state,
    icpDetail: {
      ...state.icpDetail,
      loading: false,
      error: error.message || 'Failed to load ICP details'
    }
  })),

  // Load ICP Detail actions (legacy)
  on(IcpActions.loadIcpDetail, (state) => ({
    ...state,
    icpDetail: {
      ...state.icpDetail,
      loading: true,
      error: null
    }
  })),
  
  on(IcpActions.loadIcpDetailSuccess, (state, { icp }) => ({
    ...state,
    icpDetail: {
      entity: icp,
      loading: false,
      error: null
    }
  })),
  
  on(IcpActions.loadIcpDetailFailure, (state, { error }) => ({
    ...state,
    icpDetail: {
      ...state.icpDetail,
      loading: false,
      error: error.message || 'Failed to load ICP details'
    }
  })),
  
  // Create ICP
  on(IcpActions.createIcp, (state) => ({
    ...state,
    createIcp: {
      loading: true,
      success: false,
      error: null
    }
  })),
  
  on(IcpActions.createIcpSuccess, (state, { icp }) => ({
    ...state,
    createIcp: {
      loading: false,
      success: true,
      error: null
    },
    icps: {
      ...state.icps,
      entities: [icp, ...state.icps.entities],
      pagination: {
        ...state.icps.pagination,
        total: state.icps.pagination.total + 1
      }
    }
  })),
  
  on(IcpActions.createIcpFailure, (state, { error }) => ({
    ...state,
    createIcp: {
      loading: false,
      success: false,
      error: error.message || 'Failed to create ICP'
    }
  })),
  
  // Update ICP
  on(IcpActions.updateIcp, (state) => ({
    ...state,
    updateIcp: {
      loading: true,
      success: false,
      error: null
    }
  })),
  
  on(IcpActions.updateIcpSuccess, (state, { icp }) => ({
    ...state,
    updateIcp: {
      loading: false,
      success: true,
      error: null
    },
    icps: {
      ...state.icps,
      entities: state.icps.entities.map(entity =>
        entity.id === icp.id ? icp : entity
      )
    },
    icpDetail: {
      ...state.icpDetail,
      entity: state.icpDetail.entity?.id === icp.id ? icp : state.icpDetail.entity
    }
  })),
  
  on(IcpActions.updateIcpFailure, (state, { error }) => ({
    ...state,
    updateIcp: {
      loading: false,
      success: false,
      error: error.message || 'Failed to update ICP'
    }
  })),
  
  // Delete ICP
  on(IcpActions.deleteIcp, (state) => ({
    ...state,
    deleteIcp: {
      loading: true,
      success: false,
      error: null
    }
  })),
  
  on(IcpActions.deleteIcpSuccess, (state, { id }) => ({
    ...state,
    deleteIcp: {
      loading: false,
      success: true,
      error: null
    },
    icps: {
      ...state.icps,
      entities: state.icps.entities.filter(entity => entity.id !== id),
      pagination: {
        ...state.icps.pagination,
        total: state.icps.pagination.total - 1
      }
    }
  })),
  
  on(IcpActions.deleteIcpFailure, (state, { error }) => ({
    ...state,
    deleteIcp: {
      loading: false,
      success: false,
      error: error.message || 'Failed to delete ICP'
    }
  })),
  
  // Clone ICP (reuses createIcp state shape)
  on(IcpActions.cloneIcp, (state) => ({
    ...state,
    createIcp: {
      loading: true,
      success: false,
      error: null
    }
  })),

  on(IcpActions.cloneIcpSuccess, (state, { icp }) => ({
    ...state,
    createIcp: {
      loading: false,
      success: true,
      error: null
    },
    icps: {
      ...state.icps,
      entities: [icp, ...state.icps.entities],
      pagination: {
        ...state.icps.pagination,
        total: state.icps.pagination.total + 1
      }
    }
  })),

  on(IcpActions.cloneIcpFailure, (state, { error }) => ({
    ...state,
    createIcp: {
      loading: false,
      success: false,
      error: error.message || 'Failed to clone ICP'
    }
  })),

  // Reset Actions
  on(IcpActions.resetCreateIcp, (state) => ({
    ...state,
    createIcp: {
      loading: false,
      success: false,
      error: null
    }
  })),
  
  on(IcpActions.resetUpdateIcp, (state) => ({
    ...state,
    updateIcp: {
      loading: false,
      success: false,
      error: null
    }
  })),
  
  on(IcpActions.resetDeleteIcp, (state) => ({
    ...state,
    deleteIcp: {
      loading: false,
      success: false,
      error: null
    }
  }))
);

export { IcpState } from './icp.state';